import React from "react";
import {Box} from "@mui/material";
import {Dropdown} from "../Dropdown";
import {BaseInput} from "../BaseInput";

export const ALL_REGIONS = [
  '屏東市', '潮州鎮', '東港鎮', '恆春鎮', '萬丹鄉', '長治鄉', '麟洛鄉',
  '九如鄉', '里港鄉', '鹽埔鄉', '高樹鄉', '萬巒鄉', '內埔鄉', '竹田鄉',
  '新埤鄉', '枋寮鄉', '新園鄉', '崁頂鄉', '林邊鄉', '南州鄉', '佳冬鄉',
  '琉球鄉', '車城鄉', '滿州鄉', '枋山鄉', '霧臺鄉', '瑪家鄉', '泰武鄉',
  '來義鄉', '春日鄉', '獅子鄉', '牡丹鄉', '三地門鄉'
]

interface AddressInputProps {
  values: {
    address: string;
    region: string;
  },
  onChange: (object: { address: string, region: string}) => void;
}

export const AddressInput = ({
  values = {
    address: '',
    region: '',
  },
  onChange,
}: AddressInputProps) =>  (
  <Box display="flex" flexDirection="column" justifyContent="flex-start" gap={1} style={{marginBottom: 15}}>
    <Box className="page-title">
      地址
    </Box>
    <Box display="flex" flexDirection="row" justifyContent="flex-start" flex={1} gap={2}>
      <Box display="flex" flex={1}>
        <BaseInput
          value="屏東縣"
          onChange={() => null}
          isRequired={false}
          isDisabled={true}
        />
      </Box>
      <Box display="flex" flex={1}>
        <Dropdown
          className={""}
          hasDiv={false}
          options={ALL_REGIONS}
          dataSelected={values.region}
          disabled={false}
          onChange={e => onChange({ ...values, region: e.target.value })}
          text=""
        />
      </Box>
    </Box>
    <BaseInput
      value={values.address}
      onChange={e => onChange({ ...values, address: e.target.value })}
    />
  </Box>
);
